module.exports = __webpack_public_path__ + "static/img/lbbg5.98072d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/newdownload/lbbg5.png
// module id = x1Tx
// module chunks = 0